import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Link as RouterLink } from 'react-router-dom';

export default function ListAddresses() {
    const [addresss, setaddresss] = useState(null);
    const { isLoading: isLoadingaddresss, refetch: getaddresss } = useQuery(
        "show-address",
        async () => {
          return await apiClient.get("/api/show-address");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setaddresss(res.data.wallets);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getaddresss() 
        if (isLoadingaddresss) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingaddresss? 'Loading addresss...' : 'List of Wallet addresses'}
      </Typography>
    <TableContainer component={Paper}>
        
      {addresss !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>Name</TableCell>
        <TableCell align="right">Address</TableCell>
        <TableCell align="right">Type</TableCell>
        <TableCell align="right">Display Area</TableCell>
        <TableCell align="right">Edit</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {addresss.map((address) => (
          <TableRow
            key={address.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {address.coin_name}
            </TableCell>
            <TableCell align="right">{address.address}</TableCell>
            <TableCell align="right">{address.wallet_type}</TableCell>
            <TableCell align="right">{address.display_area}</TableCell>
            <TableCell align="right"><Button component={RouterLink} to={`/edit-address/${address.id}`} startIcon={<EditIcon />}>Edit address</Button></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>
    </div>
  );
}